import * as Yup from "yup";

const areaCodeList = {
  994: "آذربایجان",
  54: "آرژانتین",
  27: "آفریقای جنوبی",
  236: "آفریقای مرکزی",
  355: "آلبانی",
  49: "آلمان",
  1: "آمریکا",
  244: "آنگولا",
  43: "اتریش",
  251: "اتیوپی",
  375: "بلاروس",
  962: "اردن",
  374: "کد ارمنستان",
  598: "اروگوئه",
  291: "اریتره",
  7371: "ازبکستان",
  34: "اسپانیا",
  61: "کد استرالیا",
  372: "استونی",
  43: "اطریش",
  93: "افغانستان",
  213: "الجزایر",
  503: "السالوادور",
  971: "کد امارات",
  62: "اندونزی",
  44: "کد انگلستان",
  25: "اوگاندا",
  380: "اوکراین",
  39: "ایتالیا",
  98: "ایران",
  353: "ایرلند",
  593: "اکوادور",
  354: "ایسلند",
  18094: "باربادوس",
  18093: "باهاما",
  973: "بحرین",
  55: "برزیل",
  673: "بروئنی",
  32: "بلژیک",
  359: "بلغارستان",
  880: "بنگلادش",
  229: "بنین",
  267: "بوتان",
  387: "بوسنی و هرزگوین",
  591: "بولیوی",
  595: "پاراگوئه",
  507: "پاناما",
  92: "پاکستان",
  351: "پرتغال",
  51: "پرو",
  95: "پنال",
  992: "تاجیکستان",
  255: "تانزانیا",
  66: "تایلند",
  886: "تایوان",
  1868: "ترینیداد",
  7363: "ترکمنستان",
  90: "ترکیه",
  216: "تونس",
  676: "تونگا",
  18099: "جامائیکا",
  359: "جزایر قناری",
  692: "جزایرمارشال",
  237: "چاد",
  86: "چین",
  42: "چک",
  45: "دانمارک",
  1767: "دومینیکا",
  1809: "دومینیکن",
  250: "رو آندا",
  7095: "روسیه",
  40: "رومانی",
  243: "زئیر",
  260: "زامبیا",
  64: "زلاند نو",
  263: "زیمبابوه",
  81: "ژاپن",
  225: "ساحل عاج",
  684: "ساموآ آمریکا",
  685: "ساموا غربی",
  94: "سریلانکا",
  1758: "سنت لوسیا",
  1784: "سنت وینسنت",
  1869: "سنت کیتس",
  65: "سنگاپو",
  221: "سنگال",
  46: "سوئد",
  41: "سوئیس",
  249: "سودان",
  597: "سورینام",
  963: "سوریه",
  252: "سومالی",
  148: "سیشل",
  56: "شیلی",
  381: "صربستان و مونته نگرو",
  966: "کد کشور عربستان",
  964: "عراق",
  968: "عمان",
  233: "غنا",
  33: "فرانسه",
  358: "فنلاند",
  679: "فیجی",
  63: "فیلیپین",
  357: "قبرس",
  7331: "قرقیزستان",
  974: "قطر",
  855: "کامبوج",
  237: "کامرون",
  1: "کانادا",
  82: "کره جنوبی",
  850: "کره شمالی",
  385: "کرواسی",
  506: "کاستاریکا",
  57: "کلمبیا",
  242: "کنگو",
  254: "کنیا",
  53: "کوبا",
  269: "کومور",
  965: "کویت",
  241: "گابون",
  220: "گامبیا",
  955: "گرجستان",
  1473: "گرنادا",
  502: "گواتمالا",
  671: "گوام",
  224: "گینه",
  240: "گینه استوایی",
  245: "گینه بیسائو",
  856: "لائوس",
  961: "لبنان",
  266: "لسوتو",
  48: "لهستان",
  352: "لوکزامبورگ",
  231: "لیبریا",
  218: "لیبی",
  265: "مالاوی",
  356: "مالت",
  960: "مالدیو",
  60: "مالزی",
  223: "مالی",
  36: "مجارستان",
  212: "مراکش",
  20: "مصر",
  976: "مغولستان",
  389: "مقدونیه",
  222: "موریتانی",
  230: "موریس",
  258: "موزامبیک",
  95: "میانمار",
  52: "مکزیک",
  674: "نائورا",
  264: "نامیبیا",
  977: "نپال",
  47: "نروژ",
  267: "نگارا پرونئی دارالسلام",
  227: "نیجر",
  505: "نیکاراگوئه",
  509: "هائی تی",
  31: "هلند",
  91: "هند",
  504: "هندوراس",
  752: "هنگ کنگ",
  39: "واتیکان",
  58: "ونزوئلا",
  84: "ویتنام",
  969: "یمن جنوبی",
  967: "یمن شمالی",
  381: "یوگسلاوی",
  30: "یونان",
};

const userAccountingInfoValidation = Yup.object().shape({
  firstName: Yup.string().required("این فیلد الزامی است"),
  lastName: Yup.string().required("این فیلد الزامی است"),
  mobileNumber: Yup.number()
    .typeError("فقط عدد وارد کنید")
    .required("این فیلد الزامی است"),
  identificationCardNumber: Yup.number()
    .typeError("فقط عدد وارد کنید")
    .required("این فیلد الزامی است"),
  // identificationCard: Yup.string().required("این فیلد الزامی است"),
});

const addBankAccountsValidation = Yup.object().shape({
  bankName: Yup.string().required("این فیلد الزامی است"),
  bankCartNumber: Yup.number()
    .typeError("فقط عدد وارد کنید")
    .required("این فیلد الزامی است"),
  bankAccountNumber: Yup.number()
    .typeError("فقط عدد وارد کنید")
    .required("این فیلد الزامی است"),
  bankShaba: Yup.number()
    .typeError("فقط عدد وارد کنید")
    .required("این فیلد الزامی است"),
});

export { userAccountingInfoValidation, addBankAccountsValidation };
